import styled from 'styled-components';

export const Header = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	padding: 24px 0;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light30};

	@media (max-width: 768px) {
		display: none;
	}
`;

export const EmptyDiv = styled.div``;

export const Month = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`;

export const MonthText = styled.div`
	font-size: 24px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-align: center;
`;

export const ArrowWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover {
		background-color: ${({ theme }) => theme.colors.transparent.light30};
	}

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		width: 20px;
		height: 20px;
	}
`;

export const Filter = styled.div`
	display: flex;
	gap: 8px;
	justify-content: flex-end;
`;

export const FilterWrapper = styled.div<{ $active?: boolean }>`
	padding: 6px 8px;
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.2s;
	background-color: ${props => props.$active ? props.theme.colors.control.primary : props.theme.colors.transparent.light10};
	color: ${props => props.$active ? props.theme.colors.text.alwaysDark : props.theme.colors.text.alwaysWhite};
	font-size: 14px;
	font-weight: 500;

	&:hover {
		background-color: ${props => props.$active ? props.theme.colors.control.hover : props.theme.colors.transparent.light30};
	}
`; 